import React from "react";
import CarMasterData from "./carMasterData";

const TypesList = () => {
  const tabeName = "carColor";

  return (
    <>
      <CarMasterData tabeName={tabeName} />
    </>
  );
};

export default TypesList;
